"use client";

import { cn } from "@/lib/utils";
import { motion, Variants } from "motion/react";
import React from "react";

type ContentAnimationProps = {
  children: React.ReactNode;
  className?: string;
  duration?: number;
  delay?: number;
  ease?: number[];
};

const ContentAnimation = ({
  children,
  className,
  duration = 0.7,
  delay = 0.5,
  ease = [0.6, 0, 0.1, 1],
}: ContentAnimationProps) => {
  const contentVariants: Variants = {
    hidden: {
      y: "100%",
    },
    visible: {
      y: "0%",
      transition: {
        duration,
        delay,
        ease,
      },
    },
  };

  return (
    <div className={cn("overflow-hidden", className)}>
      <motion.div
        variants={contentVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{
          once: true,
        }}
      >
        {children}
      </motion.div>
    </div>
  );
};

export default ContentAnimation;
